import { Box, Typography } from "@material-ui/core";
import React, { FC } from "react";
import { injectIntl, WrappedComponentProps } from "react-intl";
import expirate from "../Assets/logo-sapheer-noir.png";
import { CustomButton } from "../Common/CustomButton";
import useStyles from "./styles";
import { clearLocalStorage } from "../../services/LocalStorage";
import { FormattedMessage } from "react-intl";
import { DASHBOARD_URL } from "../../config";

const Liveness: FC<WrappedComponentProps> = (props) => {
  const classes = useStyles();

  const handleCancel = () => {
    clearLocalStorage();
    window.location.href = `${DASHBOARD_URL}/loginFromAccount`;
  };

  return (
    <Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        flexDirection="column"
        style={{ textAlign: "center" }}
      >
        <img src={expirate} width={400} alt="logo Sapheer" />
        <Typography variant="h6">
          <strong>
            <FormattedMessage id="liveness.success.token" />
          </strong>
          <strong style={{ paddingLeft: 20, fontSize: 40 }}>🎉</strong>
        </Typography>
        <Box className={classes.button} mt={2}>
          <CustomButton onClick={handleCancel}>
            <FormattedMessage id="dialogue.form.cancel" />
          </CustomButton>
        </Box>
      </Box>
    </Box>
  );
};

export default injectIntl(Liveness);
